import { Download } from 'lucide-react';
import { useCallback, useState } from 'react';
import type { ExportColumn } from '../api/exportTasks';
import { useAppStore } from '../store/useAppStore';
import { useDownloadCenterStore } from '../store/useDownloadCenterStore';
import { useToastStore } from '../store/useToastStore';

interface ReportExportButtonProps {
  reportKey: string;
  title: string;
  fileName: string;
  params: object;
  columns?: ExportColumn[];
  disabled?: boolean;
}

export function ReportExportButton({
  reportKey,
  title,
  fileName,
  params,
  columns,
  disabled,
}: ReportExportButtonProps) {
  const [submitting, setSubmitting] = useState(false);
  const brandId = useAppStore(state => state.brandId);
  const siteId = useAppStore(state => state.siteId);
  const enqueueReportExport = useDownloadCenterStore(state => state.enqueueReportExport);
  const showToast = useToastStore(state => state.show);

  const handleExport = useCallback(async () => {
    if (!brandId || disabled || submitting) return;
    setSubmitting(true);
    try {
      await enqueueReportExport({
        report_key: reportKey,
        title,
        file_name: fileName,
        brand_id: brandId,
        site_id: siteId,
        params: params as Record<string, unknown>,
        columns,
      });
      showToast('导出任务已提交，请到右上角下载中心查看', 'success');
    } catch (e) {
      showToast(e instanceof Error ? e.message : '导出任务提交失败', 'error');
    } finally {
      setSubmitting(false);
    }
  }, [brandId, columns, disabled, enqueueReportExport, fileName, params, reportKey, showToast, siteId, submitting, title]);

  return (
    <button
      type="button"
      className="btn btn-outline btn-sm"
      onClick={handleExport}
      disabled={disabled || !brandId || submitting}
      title="导出当前报表"
      style={{ display: 'inline-flex', alignItems: 'center', gap: 6, height: 32 }}
    >
      <Download size={14} strokeWidth={2} />
      {submitting ? '提交中' : '导出'}
    </button>
  );
}
